import { render, staticRenderFns } from "./Element.vue?vue&type=template&id=4df88918&scoped=true"
import script from "./Element.vue?vue&type=script&lang=js"
export * from "./Element.vue?vue&type=script&lang=js"
import style0 from "./Element.vue?vue&type=style&index=0&id=4df88918&prod&scoped=true&lang=less"
import style1 from "./Element.vue?vue&type=style&index=1&id=4df88918&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df88918",
  null
  
)

export default component.exports